import { useGqlMutation, useGqlQuery } from '@API/useAvQuery';
import { usePostUserMessage, useStartAgenticSession } from '@components/Copilot/agentHooks';
import { END_AGENTIC_SESSION, EXECUTE_CUSTOM_OPERATION, GET_FEEDBACK_CATEGORIES, SUBMIT_AGENT_FEEDBACK } from '@components/Copilot/gql';
import { FeedbackInput, OperationInput } from '@components/Copilot/types';
import { QueryKey } from '@fabric-ui/utils';
import { UseMutationOptions } from '@tanstack/react-query';
import { GraphQLError } from 'graphql';

export { usePostUserMessage, useStartAgenticSession };

export const useEndAgenticSession = (
  options?: Omit<UseMutationOptions<boolean, GraphQLError, { sessionId: string }>, 'variablesAdapter'>
) =>
  useGqlMutation<boolean, { sessionId: string }>({
    mutationKey: [QueryKey.Copilot, 'endAgenticSession'],
    mutation: END_AGENTIC_SESSION,
    ...options,
  });

export const useExecuteCustomOperation = (
  options?: Omit<UseMutationOptions<string, GraphQLError, { operationInput: OperationInput }>, 'variablesAdapter'>
) =>
  useGqlMutation<string, { operationInput: OperationInput }>({
    mutationKey: [QueryKey.Copilot, 'executeCustomOperation'],
    mutation: EXECUTE_CUSTOM_OPERATION,
    ...options,
  });

export interface FeedbackCategoryOption {
  key: string;
  label: string;
}

interface GetFeedbackCategoriesResponse {
  getFeedbackCategories: FeedbackCategoryOption[];
}

export const useGetFeedbackCategories = ({ enabled = true }: { enabled?: boolean } = {}) =>
  useGqlQuery<GetFeedbackCategoriesResponse, FeedbackCategoryOption[]>({
    queryKey: [QueryKey.Copilot, 'getFeedbackCategories'],
    query: GET_FEEDBACK_CATEGORIES,
    enabled,
    staleTime: Infinity,
  });

export interface FeedbackResponse {
  success: boolean;
  loopId: string;
  isUpdate: boolean;
}

export const useSubmitAgentFeedback = (
  options?: Omit<UseMutationOptions<FeedbackResponse, GraphQLError, { feedbackInput: FeedbackInput }>, 'variablesAdapter'>
) =>
  useGqlMutation<FeedbackResponse, { feedbackInput: FeedbackInput }>({
    mutationKey: [QueryKey.Copilot, 'submitAgentFeedback'],
    mutation: SUBMIT_AGENT_FEEDBACK,
    ...options,
  });
